import React, { useState } from 'react'
import SimpleModal from '../../../components/Modals/SimpleModal'
import AddressAbstractionComponent from './AddressAbstractionComponent'

export default function ResidentialAddressModal({
  defaultValue = {},
  submitSavingAddress = () => { },
  disabledType = false,
  currentAddress = {},
  setCurrentAddress = () => { },
  open = false,
  onClose = () => { }
}) {
  const [errors, setErrors] = useState({})

  return (
    <SimpleModal size='lg'
      open={open}
      onSave={() => submitSavingAddress(currentAddress, setErrors)}
      onClose={() => { onClose(); setCurrentAddress({ ...defaultValue }) }}
      title='Address'
    >
      <AddressAbstractionComponent defaultValue={defaultValue} errors={errors} disabledType={disabledType} currentAddress={currentAddress} setCurrentAddress={setCurrentAddress} />
    </SimpleModal>
  )
}